import axios from "axios"

export default {
  createOrder(productId) {
    const url = "pem/thrivecart/create-order"

    return axios.post(url, { productIds: [productId] }).then(response => {
      return response.data
    })
  },

  getSubscription() {
    const url = "pem/subscription"

    return axios.get(url).then(response => {
      return response.data
    })
  },

  cancelSubscription() {
    const url = "pem/thrivecart/cancel-subscription"

    return axios.post(url).then(response => {
      return response.data
    })
  },
}
